import { render, staticRenderFns } from "./MerchantManage.vue?vue&type=template&id=9c2b3bfe&scoped=true&"
import script from "./MerchantManage.vue?vue&type=script&lang=js&"
export * from "./MerchantManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2b3bfe",
  null
  
)

export default component.exports